export const SERVICE_CODE = 'DEAL' + '_SERVICE';
